/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LandingPageV1RouteImport } from './routes/landing-page-v1'
import { Route as LandingPageV2RouteImport } from './routes/landing-page-v2'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OnboardingSuccessRouteImport } from './routes/onboarding-success'
import { Route as VideoRouteImport } from './routes/video'
import { Route as cleanerAuthLayoutRouteImport } from './routes/(cleaner)/_auth-layout'
import { Route as cleanerAuthenticatedRouteImport } from './routes/(cleaner)/_authenticated'
import { Route as cleanerRegistrationRouteImport } from './routes/(cleaner)/_registration'
import { Route as cleanerApplicationSubmittedRouteImport } from './routes/(cleaner)/application-submitted'
import { Route as cleanerStatusVerificationRouteImport } from './routes/(cleaner)/status-verification'
import { Route as consumerAuthLayoutRouteImport } from './routes/(consumer)/_auth-layout'
import { Route as consumerAuthenticatedRouteImport } from './routes/(consumer)/_authenticated'
import { Route as consumerPublicRouteImport } from './routes/(consumer)/_public'
import { Route as CheckrDisclosureConsentEmbedRouteImport } from './routes/checkr.disclosure-consent-embed'
import { Route as EmbedSignupRouteImport } from './routes/embed.signup'
import { Route as cleanerApplyCleanerIndexRouteImport } from './routes/(cleaner)/apply-cleaner/index'
import { Route as cleanerApplyCleanerBackgroundCheckRouteImport } from './routes/(cleaner)/apply-cleaner/background-check'
import { Route as cleanerApplyCleanerCompletedRouteImport } from './routes/(cleaner)/apply-cleaner/completed'
import { Route as cleanerApplyCleanerPersonalInfoRouteImport } from './routes/(cleaner)/apply-cleaner/personal-info'
import { Route as cleanerApplyCleanerSignupRouteImport } from './routes/(cleaner)/apply-cleaner/signup'
import { Route as cleanerCleanerContactUsRouteImport } from './routes/(cleaner)/cleaner.contact-us'
import { Route as cleanerCleanerFaqRouteImport } from './routes/(cleaner)/cleaner.faq'
import { Route as consumerbookingsBookingRouteImport } from './routes/(consumer)/(bookings)/booking'
import { Route as consumerAuthLayoutLoginRouteImport } from './routes/(consumer)/_auth-layout/login'
import { Route as consumerAuthLayoutOtpRouteImport } from './routes/(consumer)/_auth-layout/otp'
import { Route as consumerAuthLayoutRegisterRouteImport } from './routes/(consumer)/_auth-layout/register'
import { Route as consumerAuthenticatedDashboardRouteImport } from './routes/(consumer)/_authenticated/dashboard'
import { Route as consumerAuthenticatedEditProfileRouteImport } from './routes/(consumer)/_authenticated/edit-profile'
import { Route as consumerAuthenticatedFavoritesRouteImport } from './routes/(consumer)/_authenticated/favorites'
import { Route as consumerAuthenticatedNotificationsRouteImport } from './routes/(consumer)/_authenticated/notifications'
import { Route as consumerAuthenticatedRequestDeleteAccountRouteImport } from './routes/(consumer)/_authenticated/request-delete-account'
import { Route as consumerAuthenticatedViewProfileRouteImport } from './routes/(consumer)/_authenticated/view-profile'
import { Route as consumerPublicAboutUsRouteImport } from './routes/(consumer)/_public/about-us'
import { Route as consumerPublicContactUsRouteImport } from './routes/(consumer)/_public/contact-us'
import { Route as consumerPublicCookiePolicyRouteImport } from './routes/(consumer)/_public/cookie-policy'
import { Route as consumerPublicFaqRouteImport } from './routes/(consumer)/_public/faq'
import { Route as consumerPublicHomeRouteImport } from './routes/(consumer)/_public/home'
import { Route as consumerPublicOurServiceRouteImport } from './routes/(consumer)/_public/our-service'
import { Route as consumerPublicPrivacyHealthDataRouteImport } from './routes/(consumer)/_public/privacy-health-data'
import { Route as consumerPublicPrivacyPolicyRouteImport } from './routes/(consumer)/_public/privacy-policy'
import { Route as consumerPublicTermsOfServiceRouteImport } from './routes/(consumer)/_public/terms-of-service'
import { Route as cleanerAuthLayoutCleanerLoginRouteImport } from './routes/(cleaner)/_auth-layout/cleaner.login'
import { Route as cleanerAuthLayoutCleanerOtpRouteImport } from './routes/(cleaner)/_auth-layout/cleaner.otp'
import { Route as cleanerAuthenticatedCleanerAvailabilityRouteImport } from './routes/(cleaner)/_authenticated/cleaner.availability'
import { Route as cleanerAuthenticatedCleanerBookingDetailsRouteImport } from './routes/(cleaner)/_authenticated/cleaner.booking-details'
import { Route as cleanerAuthenticatedCleanerBookingDetailsRequestRouteImport } from './routes/(cleaner)/_authenticated/cleaner.booking-details-request'
import { Route as cleanerAuthenticatedCleanerBookingsRouteImport } from './routes/(cleaner)/_authenticated/cleaner.bookings'
import { Route as cleanerAuthenticatedCleanerDashboardRouteImport } from './routes/(cleaner)/_authenticated/cleaner.dashboard'
import { Route as cleanerAuthenticatedCleanerEditProfileRouteImport } from './routes/(cleaner)/_authenticated/cleaner.edit-profile'
import { Route as cleanerAuthenticatedCleanerNotificationsRouteImport } from './routes/(cleaner)/_authenticated/cleaner.notifications'
import { Route as cleanerAuthenticatedCleanerOpportunitiesRouteImport } from './routes/(cleaner)/_authenticated/cleaner.opportunities'
import { Route as cleanerAuthenticatedCleanerOpportunitiesDetailsRouteImport } from './routes/(cleaner)/_authenticated/cleaner.opportunities-details'
import { Route as cleanerAuthenticatedCleanerPayoutRouteImport } from './routes/(cleaner)/_authenticated/cleaner.payout'
import { Route as cleanerAuthenticatedCleanerPayoutAddBankAccountRouteImport } from './routes/(cleaner)/_authenticated/cleaner.payout-add-bank-account'
import { Route as cleanerAuthenticatedCleanerPayoutEditRouteImport } from './routes/(cleaner)/_authenticated/cleaner.payout-edit'
import { Route as cleanerAuthenticatedCleanerPayoutNowRouteImport } from './routes/(cleaner)/_authenticated/cleaner.payout-now'
import { Route as cleanerAuthenticatedCleanerReviewsRouteImport } from './routes/(cleaner)/_authenticated/cleaner.reviews'
import { Route as cleanerAuthenticatedCleanerViewProfileRouteImport } from './routes/(cleaner)/_authenticated/cleaner.view-profile'
import { Route as cleanerAuthenticatedCleanerWorkSetupRouteImport } from './routes/(cleaner)/_authenticated/cleaner.work-setup'
import { Route as cleanerRegistrationCleanerSignupCompletedRouteImport } from './routes/(cleaner)/_registration/cleaner.signup-completed'
import { Route as cleanerRegistrationCleanerSignupInfoRouteImport } from './routes/(cleaner)/_registration/cleaner.signup-info'
import { Route as cleanerRegistrationCleanerSignupSetupRouteImport } from './routes/(cleaner)/_registration/cleaner.signup-setup'
import { Route as cleanerRegistrationCleanerSignupTermsRouteImport } from './routes/(cleaner)/_registration/cleaner.signup-terms'
import { Route as consumerAuthLayoutLoginTokenRouteImport } from './routes/(consumer)/_auth-layout/login.$token'
import { Route as consumerAuthenticatedBookingsIndexRouteImport } from './routes/(consumer)/_authenticated/bookings/index'
import { Route as consumerAuthenticatedBookingsIdRouteImport } from './routes/(consumer)/_authenticated/bookings/$id'
import { Route as consumerAuthenticatedBookingsHistoryRouteImport } from './routes/(consumer)/_authenticated/bookings/history'
import { Route as consumerAuthenticatedChatsIdRouteImport } from './routes/(consumer)/_authenticated/chats.$id'
import { Route as consumerAuthenticatedMyWalletIndexRouteImport } from './routes/(consumer)/_authenticated/my-wallet/index'
import { Route as consumerAuthenticatedMyWalletAddPaymentCardRouteImport } from './routes/(consumer)/_authenticated/my-wallet/add-payment-card'
import { Route as consumerAuthenticatedMyWalletTopupBalanceRouteImport } from './routes/(consumer)/_authenticated/my-wallet/topup-balance'
import { Route as consumerAuthenticatedMyWalletWithdrawRouteImport } from './routes/(consumer)/_authenticated/my-wallet/withdraw'
import { Route as cleanerAuthenticatedCleanerBookingsIdRouteImport } from './routes/(cleaner)/_authenticated/cleaner.bookings.$id'
import { Route as cleanerAuthenticatedCleanerOpportunitiesIdRouteImport } from './routes/(cleaner)/_authenticated/cleaner.opportunities.$id'
import { Route as consumerAuthenticatedBookingsIdPaymentRouteImport } from './routes/(consumer)/_authenticated/bookings/$id/payment'
import { Route as consumerAuthenticatedMyWalletWithdrawIndexRouteImport } from './routes/(consumer)/_authenticated/my-wallet/withdraw.index'
import { Route as consumerAuthenticatedMyWalletWithdrawSuccessRouteImport } from './routes/(consumer)/_authenticated/my-wallet/withdraw.success'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingPageV1Route = LandingPageV1RouteImport.update({
  id: '/landing-page-v1',
  path: '/landing-page-v1',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingPageV2Route = LandingPageV2RouteImport.update({
  id: '/landing-page-v2',
  path: '/landing-page-v2',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingSuccessRoute = OnboardingSuccessRouteImport.update({
  id: '/onboarding-success',
  path: '/onboarding-success',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoRoute = VideoRouteImport.update({
  id: '/video',
  path: '/video',
  getParentRoute: () => rootRouteImport,
} as any)
const cleanerAuthLayoutRoute = cleanerAuthLayoutRouteImport.update({
  id: '/(cleaner)/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const cleanerAuthenticatedRoute = cleanerAuthenticatedRouteImport.update({
  id: '/(cleaner)/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const cleanerRegistrationRoute = cleanerRegistrationRouteImport.update({
  id: '/(cleaner)/_registration',
  getParentRoute: () => rootRouteImport,
} as any)
const cleanerApplicationSubmittedRoute =
  cleanerApplicationSubmittedRouteImport.update({
    id: '/(cleaner)/application-submitted',
    path: '/application-submitted',
    getParentRoute: () => rootRouteImport,
  } as any)
const cleanerStatusVerificationRoute =
  cleanerStatusVerificationRouteImport.update({
    id: '/(cleaner)/status-verification',
    path: '/status-verification',
    getParentRoute: () => rootRouteImport,
  } as any)
const consumerAuthLayoutRoute = consumerAuthLayoutRouteImport.update({
  id: '/(consumer)/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const consumerAuthenticatedRoute = consumerAuthenticatedRouteImport.update({
  id: '/(consumer)/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const consumerPublicRoute = consumerPublicRouteImport.update({
  id: '/(consumer)/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckrDisclosureConsentEmbedRoute =
  CheckrDisclosureConsentEmbedRouteImport.update({
    id: '/checkr/disclosure-consent-embed',
    path: '/checkr/disclosure-consent-embed',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmbedSignupRoute = EmbedSignupRouteImport.update({
  id: '/embed/signup',
  path: '/embed/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const cleanerApplyCleanerIndexRoute =
  cleanerApplyCleanerIndexRouteImport.update({
    id: '/(cleaner)/apply-cleaner/',
    path: '/apply-cleaner/',
    getParentRoute: () => rootRouteImport,
  } as any)
const cleanerApplyCleanerBackgroundCheckRoute =
  cleanerApplyCleanerBackgroundCheckRouteImport.update({
    id: '/(cleaner)/apply-cleaner/background-check',
    path: '/apply-cleaner/background-check',
    getParentRoute: () => rootRouteImport,
  } as any)
const cleanerApplyCleanerCompletedRoute =
  cleanerApplyCleanerCompletedRouteImport.update({
    id: '/(cleaner)/apply-cleaner/completed',
    path: '/apply-cleaner/completed',
    getParentRoute: () => rootRouteImport,
  } as any)
const cleanerApplyCleanerPersonalInfoRoute =
  cleanerApplyCleanerPersonalInfoRouteImport.update({
    id: '/(cleaner)/apply-cleaner/personal-info',
    path: '/apply-cleaner/personal-info',
    getParentRoute: () => rootRouteImport,
  } as any)
const cleanerApplyCleanerSignupRoute =
  cleanerApplyCleanerSignupRouteImport.update({
    id: '/(cleaner)/apply-cleaner/signup',
    path: '/apply-cleaner/signup',
    getParentRoute: () => rootRouteImport,
  } as any)
const cleanerCleanerContactUsRoute = cleanerCleanerContactUsRouteImport.update({
  id: '/(cleaner)/cleaner/contact-us',
  path: '/cleaner/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const cleanerCleanerFaqRoute = cleanerCleanerFaqRouteImport.update({
  id: '/(cleaner)/cleaner/faq',
  path: '/cleaner/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const consumerbookingsBookingRoute = consumerbookingsBookingRouteImport.update({
  id: '/(consumer)/(bookings)/booking',
  path: '/booking',
  getParentRoute: () => rootRouteImport,
} as any)
const consumerAuthLayoutLoginRoute = consumerAuthLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => consumerAuthLayoutRoute,
} as any)
const consumerAuthLayoutOtpRoute = consumerAuthLayoutOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => consumerAuthLayoutRoute,
} as any)
const consumerAuthLayoutRegisterRoute =
  consumerAuthLayoutRegisterRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => consumerAuthLayoutRoute,
  } as any)
const consumerAuthenticatedDashboardRoute =
  consumerAuthenticatedDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedEditProfileRoute =
  consumerAuthenticatedEditProfileRouteImport.update({
    id: '/edit-profile',
    path: '/edit-profile',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedFavoritesRoute =
  consumerAuthenticatedFavoritesRouteImport.update({
    id: '/favorites',
    path: '/favorites',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedNotificationsRoute =
  consumerAuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedRequestDeleteAccountRoute =
  consumerAuthenticatedRequestDeleteAccountRouteImport.update({
    id: '/request-delete-account',
    path: '/request-delete-account',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedViewProfileRoute =
  consumerAuthenticatedViewProfileRouteImport.update({
    id: '/view-profile',
    path: '/view-profile',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerPublicAboutUsRoute = consumerPublicAboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => consumerPublicRoute,
} as any)
const consumerPublicContactUsRoute = consumerPublicContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => consumerPublicRoute,
} as any)
const consumerPublicCookiePolicyRoute =
  consumerPublicCookiePolicyRouteImport.update({
    id: '/cookie-policy',
    path: '/cookie-policy',
    getParentRoute: () => consumerPublicRoute,
  } as any)
const consumerPublicFaqRoute = consumerPublicFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => consumerPublicRoute,
} as any)
const consumerPublicHomeRoute = consumerPublicHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => consumerPublicRoute,
} as any)
const consumerPublicOurServiceRoute =
  consumerPublicOurServiceRouteImport.update({
    id: '/our-service',
    path: '/our-service',
    getParentRoute: () => consumerPublicRoute,
  } as any)
const consumerPublicPrivacyHealthDataRoute =
  consumerPublicPrivacyHealthDataRouteImport.update({
    id: '/privacy-health-data',
    path: '/privacy-health-data',
    getParentRoute: () => consumerPublicRoute,
  } as any)
const consumerPublicPrivacyPolicyRoute =
  consumerPublicPrivacyPolicyRouteImport.update({
    id: '/privacy-policy',
    path: '/privacy-policy',
    getParentRoute: () => consumerPublicRoute,
  } as any)
const consumerPublicTermsOfServiceRoute =
  consumerPublicTermsOfServiceRouteImport.update({
    id: '/terms-of-service',
    path: '/terms-of-service',
    getParentRoute: () => consumerPublicRoute,
  } as any)
const cleanerAuthLayoutCleanerLoginRoute =
  cleanerAuthLayoutCleanerLoginRouteImport.update({
    id: '/cleaner/login',
    path: '/cleaner/login',
    getParentRoute: () => cleanerAuthLayoutRoute,
  } as any)
const cleanerAuthLayoutCleanerOtpRoute =
  cleanerAuthLayoutCleanerOtpRouteImport.update({
    id: '/cleaner/otp',
    path: '/cleaner/otp',
    getParentRoute: () => cleanerAuthLayoutRoute,
  } as any)
const cleanerAuthenticatedCleanerAvailabilityRoute =
  cleanerAuthenticatedCleanerAvailabilityRouteImport.update({
    id: '/cleaner/availability',
    path: '/cleaner/availability',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerBookingDetailsRoute =
  cleanerAuthenticatedCleanerBookingDetailsRouteImport.update({
    id: '/cleaner/booking-details',
    path: '/cleaner/booking-details',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerBookingDetailsRequestRoute =
  cleanerAuthenticatedCleanerBookingDetailsRequestRouteImport.update({
    id: '/cleaner/booking-details-request',
    path: '/cleaner/booking-details-request',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerBookingsRoute =
  cleanerAuthenticatedCleanerBookingsRouteImport.update({
    id: '/cleaner/bookings',
    path: '/cleaner/bookings',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerDashboardRoute =
  cleanerAuthenticatedCleanerDashboardRouteImport.update({
    id: '/cleaner/dashboard',
    path: '/cleaner/dashboard',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerEditProfileRoute =
  cleanerAuthenticatedCleanerEditProfileRouteImport.update({
    id: '/cleaner/edit-profile',
    path: '/cleaner/edit-profile',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerNotificationsRoute =
  cleanerAuthenticatedCleanerNotificationsRouteImport.update({
    id: '/cleaner/notifications',
    path: '/cleaner/notifications',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerOpportunitiesRoute =
  cleanerAuthenticatedCleanerOpportunitiesRouteImport.update({
    id: '/cleaner/opportunities',
    path: '/cleaner/opportunities',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerOpportunitiesDetailsRoute =
  cleanerAuthenticatedCleanerOpportunitiesDetailsRouteImport.update({
    id: '/cleaner/opportunities-details',
    path: '/cleaner/opportunities-details',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerPayoutRoute =
  cleanerAuthenticatedCleanerPayoutRouteImport.update({
    id: '/cleaner/payout',
    path: '/cleaner/payout',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerPayoutAddBankAccountRoute =
  cleanerAuthenticatedCleanerPayoutAddBankAccountRouteImport.update({
    id: '/cleaner/payout-add-bank-account',
    path: '/cleaner/payout-add-bank-account',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerPayoutEditRoute =
  cleanerAuthenticatedCleanerPayoutEditRouteImport.update({
    id: '/cleaner/payout-edit',
    path: '/cleaner/payout-edit',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerPayoutNowRoute =
  cleanerAuthenticatedCleanerPayoutNowRouteImport.update({
    id: '/cleaner/payout-now',
    path: '/cleaner/payout-now',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerReviewsRoute =
  cleanerAuthenticatedCleanerReviewsRouteImport.update({
    id: '/cleaner/reviews',
    path: '/cleaner/reviews',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerViewProfileRoute =
  cleanerAuthenticatedCleanerViewProfileRouteImport.update({
    id: '/cleaner/view-profile',
    path: '/cleaner/view-profile',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerWorkSetupRoute =
  cleanerAuthenticatedCleanerWorkSetupRouteImport.update({
    id: '/cleaner/work-setup',
    path: '/cleaner/work-setup',
    getParentRoute: () => cleanerAuthenticatedRoute,
  } as any)
const cleanerRegistrationCleanerSignupCompletedRoute =
  cleanerRegistrationCleanerSignupCompletedRouteImport.update({
    id: '/cleaner/signup-completed',
    path: '/cleaner/signup-completed',
    getParentRoute: () => cleanerRegistrationRoute,
  } as any)
const cleanerRegistrationCleanerSignupInfoRoute =
  cleanerRegistrationCleanerSignupInfoRouteImport.update({
    id: '/cleaner/signup-info',
    path: '/cleaner/signup-info',
    getParentRoute: () => cleanerRegistrationRoute,
  } as any)
const cleanerRegistrationCleanerSignupSetupRoute =
  cleanerRegistrationCleanerSignupSetupRouteImport.update({
    id: '/cleaner/signup-setup',
    path: '/cleaner/signup-setup',
    getParentRoute: () => cleanerRegistrationRoute,
  } as any)
const cleanerRegistrationCleanerSignupTermsRoute =
  cleanerRegistrationCleanerSignupTermsRouteImport.update({
    id: '/cleaner/signup-terms',
    path: '/cleaner/signup-terms',
    getParentRoute: () => cleanerRegistrationRoute,
  } as any)
const consumerAuthLayoutLoginTokenRoute =
  consumerAuthLayoutLoginTokenRouteImport.update({
    id: '/$token',
    path: '/$token',
    getParentRoute: () => consumerAuthLayoutLoginRoute,
  } as any)
const consumerAuthenticatedBookingsIndexRoute =
  consumerAuthenticatedBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedBookingsIdRoute =
  consumerAuthenticatedBookingsIdRouteImport.update({
    id: '/bookings/$id',
    path: '/bookings/$id',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedBookingsHistoryRoute =
  consumerAuthenticatedBookingsHistoryRouteImport.update({
    id: '/bookings/history',
    path: '/bookings/history',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedChatsIdRoute =
  consumerAuthenticatedChatsIdRouteImport.update({
    id: '/chats/$id',
    path: '/chats/$id',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedMyWalletIndexRoute =
  consumerAuthenticatedMyWalletIndexRouteImport.update({
    id: '/my-wallet/',
    path: '/my-wallet/',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedMyWalletAddPaymentCardRoute =
  consumerAuthenticatedMyWalletAddPaymentCardRouteImport.update({
    id: '/my-wallet/add-payment-card',
    path: '/my-wallet/add-payment-card',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedMyWalletTopupBalanceRoute =
  consumerAuthenticatedMyWalletTopupBalanceRouteImport.update({
    id: '/my-wallet/topup-balance',
    path: '/my-wallet/topup-balance',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const consumerAuthenticatedMyWalletWithdrawRoute =
  consumerAuthenticatedMyWalletWithdrawRouteImport.update({
    id: '/my-wallet/withdraw',
    path: '/my-wallet/withdraw',
    getParentRoute: () => consumerAuthenticatedRoute,
  } as any)
const cleanerAuthenticatedCleanerBookingsIdRoute =
  cleanerAuthenticatedCleanerBookingsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => cleanerAuthenticatedCleanerBookingsRoute,
  } as any)
const cleanerAuthenticatedCleanerOpportunitiesIdRoute =
  cleanerAuthenticatedCleanerOpportunitiesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => cleanerAuthenticatedCleanerOpportunitiesRoute,
  } as any)
const consumerAuthenticatedBookingsIdPaymentRoute =
  consumerAuthenticatedBookingsIdPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => consumerAuthenticatedBookingsIdRoute,
  } as any)
const consumerAuthenticatedMyWalletWithdrawIndexRoute =
  consumerAuthenticatedMyWalletWithdrawIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => consumerAuthenticatedMyWalletWithdrawRoute,
  } as any)
const consumerAuthenticatedMyWalletWithdrawSuccessRoute =
  consumerAuthenticatedMyWalletWithdrawSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => consumerAuthenticatedMyWalletWithdrawRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/landing-page-v1': typeof LandingPageV1Route
  '/landing-page-v2': typeof LandingPageV2Route
  '/onboarding': typeof OnboardingRoute
  '/onboarding-success': typeof OnboardingSuccessRoute
  '/video': typeof VideoRoute
  '/application-submitted': typeof cleanerApplicationSubmittedRoute
  '/status-verification': typeof cleanerStatusVerificationRoute
  '/checkr/disclosure-consent-embed': typeof CheckrDisclosureConsentEmbedRoute
  '/embed/signup': typeof EmbedSignupRoute
  '/apply-cleaner/background-check': typeof cleanerApplyCleanerBackgroundCheckRoute
  '/apply-cleaner/completed': typeof cleanerApplyCleanerCompletedRoute
  '/apply-cleaner/personal-info': typeof cleanerApplyCleanerPersonalInfoRoute
  '/apply-cleaner/signup': typeof cleanerApplyCleanerSignupRoute
  '/cleaner/contact-us': typeof cleanerCleanerContactUsRoute
  '/cleaner/faq': typeof cleanerCleanerFaqRoute
  '/booking': typeof consumerbookingsBookingRoute
  '/login': typeof consumerAuthLayoutLoginRouteWithChildren
  '/otp': typeof consumerAuthLayoutOtpRoute
  '/register': typeof consumerAuthLayoutRegisterRoute
  '/dashboard': typeof consumerAuthenticatedDashboardRoute
  '/edit-profile': typeof consumerAuthenticatedEditProfileRoute
  '/favorites': typeof consumerAuthenticatedFavoritesRoute
  '/notifications': typeof consumerAuthenticatedNotificationsRoute
  '/request-delete-account': typeof consumerAuthenticatedRequestDeleteAccountRoute
  '/view-profile': typeof consumerAuthenticatedViewProfileRoute
  '/about-us': typeof consumerPublicAboutUsRoute
  '/contact-us': typeof consumerPublicContactUsRoute
  '/cookie-policy': typeof consumerPublicCookiePolicyRoute
  '/faq': typeof consumerPublicFaqRoute
  '/home': typeof consumerPublicHomeRoute
  '/our-service': typeof consumerPublicOurServiceRoute
  '/privacy-health-data': typeof consumerPublicPrivacyHealthDataRoute
  '/privacy-policy': typeof consumerPublicPrivacyPolicyRoute
  '/terms-of-service': typeof consumerPublicTermsOfServiceRoute
  '/apply-cleaner/': typeof cleanerApplyCleanerIndexRoute
  '/cleaner/login': typeof cleanerAuthLayoutCleanerLoginRoute
  '/cleaner/otp': typeof cleanerAuthLayoutCleanerOtpRoute
  '/cleaner/availability': typeof cleanerAuthenticatedCleanerAvailabilityRoute
  '/cleaner/booking-details': typeof cleanerAuthenticatedCleanerBookingDetailsRoute
  '/cleaner/booking-details-request': typeof cleanerAuthenticatedCleanerBookingDetailsRequestRoute
  '/cleaner/bookings': typeof cleanerAuthenticatedCleanerBookingsRouteWithChildren
  '/cleaner/dashboard': typeof cleanerAuthenticatedCleanerDashboardRoute
  '/cleaner/edit-profile': typeof cleanerAuthenticatedCleanerEditProfileRoute
  '/cleaner/notifications': typeof cleanerAuthenticatedCleanerNotificationsRoute
  '/cleaner/opportunities': typeof cleanerAuthenticatedCleanerOpportunitiesRouteWithChildren
  '/cleaner/opportunities-details': typeof cleanerAuthenticatedCleanerOpportunitiesDetailsRoute
  '/cleaner/payout': typeof cleanerAuthenticatedCleanerPayoutRoute
  '/cleaner/payout-add-bank-account': typeof cleanerAuthenticatedCleanerPayoutAddBankAccountRoute
  '/cleaner/payout-edit': typeof cleanerAuthenticatedCleanerPayoutEditRoute
  '/cleaner/payout-now': typeof cleanerAuthenticatedCleanerPayoutNowRoute
  '/cleaner/reviews': typeof cleanerAuthenticatedCleanerReviewsRoute
  '/cleaner/view-profile': typeof cleanerAuthenticatedCleanerViewProfileRoute
  '/cleaner/work-setup': typeof cleanerAuthenticatedCleanerWorkSetupRoute
  '/cleaner/signup-completed': typeof cleanerRegistrationCleanerSignupCompletedRoute
  '/cleaner/signup-info': typeof cleanerRegistrationCleanerSignupInfoRoute
  '/cleaner/signup-setup': typeof cleanerRegistrationCleanerSignupSetupRoute
  '/cleaner/signup-terms': typeof cleanerRegistrationCleanerSignupTermsRoute
  '/login/$token': typeof consumerAuthLayoutLoginTokenRoute
  '/bookings/$id': typeof consumerAuthenticatedBookingsIdRouteWithChildren
  '/bookings/history': typeof consumerAuthenticatedBookingsHistoryRoute
  '/chats/$id': typeof consumerAuthenticatedChatsIdRoute
  '/my-wallet/add-payment-card': typeof consumerAuthenticatedMyWalletAddPaymentCardRoute
  '/my-wallet/topup-balance': typeof consumerAuthenticatedMyWalletTopupBalanceRoute
  '/my-wallet/withdraw': typeof consumerAuthenticatedMyWalletWithdrawRouteWithChildren
  '/bookings/': typeof consumerAuthenticatedBookingsIndexRoute
  '/my-wallet/': typeof consumerAuthenticatedMyWalletIndexRoute
  '/cleaner/bookings/$id': typeof cleanerAuthenticatedCleanerBookingsIdRoute
  '/cleaner/opportunities/$id': typeof cleanerAuthenticatedCleanerOpportunitiesIdRoute
  '/bookings/$id/payment': typeof consumerAuthenticatedBookingsIdPaymentRoute
  '/my-wallet/withdraw/success': typeof consumerAuthenticatedMyWalletWithdrawSuccessRoute
  '/my-wallet/withdraw/': typeof consumerAuthenticatedMyWalletWithdrawIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/landing-page-v1': typeof LandingPageV1Route
  '/landing-page-v2': typeof LandingPageV2Route
  '/onboarding': typeof OnboardingRoute
  '/onboarding-success': typeof OnboardingSuccessRoute
  '/video': typeof VideoRoute
  '/application-submitted': typeof cleanerApplicationSubmittedRoute
  '/status-verification': typeof cleanerStatusVerificationRoute
  '/checkr/disclosure-consent-embed': typeof CheckrDisclosureConsentEmbedRoute
  '/embed/signup': typeof EmbedSignupRoute
  '/apply-cleaner/background-check': typeof cleanerApplyCleanerBackgroundCheckRoute
  '/apply-cleaner/completed': typeof cleanerApplyCleanerCompletedRoute
  '/apply-cleaner/personal-info': typeof cleanerApplyCleanerPersonalInfoRoute
  '/apply-cleaner/signup': typeof cleanerApplyCleanerSignupRoute
  '/cleaner/contact-us': typeof cleanerCleanerContactUsRoute
  '/cleaner/faq': typeof cleanerCleanerFaqRoute
  '/booking': typeof consumerbookingsBookingRoute
  '/login': typeof consumerAuthLayoutLoginRouteWithChildren
  '/otp': typeof consumerAuthLayoutOtpRoute
  '/register': typeof consumerAuthLayoutRegisterRoute
  '/dashboard': typeof consumerAuthenticatedDashboardRoute
  '/edit-profile': typeof consumerAuthenticatedEditProfileRoute
  '/favorites': typeof consumerAuthenticatedFavoritesRoute
  '/notifications': typeof consumerAuthenticatedNotificationsRoute
  '/request-delete-account': typeof consumerAuthenticatedRequestDeleteAccountRoute
  '/view-profile': typeof consumerAuthenticatedViewProfileRoute
  '/about-us': typeof consumerPublicAboutUsRoute
  '/contact-us': typeof consumerPublicContactUsRoute
  '/cookie-policy': typeof consumerPublicCookiePolicyRoute
  '/faq': typeof consumerPublicFaqRoute
  '/home': typeof consumerPublicHomeRoute
  '/our-service': typeof consumerPublicOurServiceRoute
  '/privacy-health-data': typeof consumerPublicPrivacyHealthDataRoute
  '/privacy-policy': typeof consumerPublicPrivacyPolicyRoute
  '/terms-of-service': typeof consumerPublicTermsOfServiceRoute
  '/apply-cleaner': typeof cleanerApplyCleanerIndexRoute
  '/cleaner/login': typeof cleanerAuthLayoutCleanerLoginRoute
  '/cleaner/otp': typeof cleanerAuthLayoutCleanerOtpRoute
  '/cleaner/availability': typeof cleanerAuthenticatedCleanerAvailabilityRoute
  '/cleaner/booking-details': typeof cleanerAuthenticatedCleanerBookingDetailsRoute
  '/cleaner/booking-details-request': typeof cleanerAuthenticatedCleanerBookingDetailsRequestRoute
  '/cleaner/bookings': typeof cleanerAuthenticatedCleanerBookingsRouteWithChildren
  '/cleaner/dashboard': typeof cleanerAuthenticatedCleanerDashboardRoute
  '/cleaner/edit-profile': typeof cleanerAuthenticatedCleanerEditProfileRoute
  '/cleaner/notifications': typeof cleanerAuthenticatedCleanerNotificationsRoute
  '/cleaner/opportunities': typeof cleanerAuthenticatedCleanerOpportunitiesRouteWithChildren
  '/cleaner/opportunities-details': typeof cleanerAuthenticatedCleanerOpportunitiesDetailsRoute
  '/cleaner/payout': typeof cleanerAuthenticatedCleanerPayoutRoute
  '/cleaner/payout-add-bank-account': typeof cleanerAuthenticatedCleanerPayoutAddBankAccountRoute
  '/cleaner/payout-edit': typeof cleanerAuthenticatedCleanerPayoutEditRoute
  '/cleaner/payout-now': typeof cleanerAuthenticatedCleanerPayoutNowRoute
  '/cleaner/reviews': typeof cleanerAuthenticatedCleanerReviewsRoute
  '/cleaner/view-profile': typeof cleanerAuthenticatedCleanerViewProfileRoute
  '/cleaner/work-setup': typeof cleanerAuthenticatedCleanerWorkSetupRoute
  '/cleaner/signup-completed': typeof cleanerRegistrationCleanerSignupCompletedRoute
  '/cleaner/signup-info': typeof cleanerRegistrationCleanerSignupInfoRoute
  '/cleaner/signup-setup': typeof cleanerRegistrationCleanerSignupSetupRoute
  '/cleaner/signup-terms': typeof cleanerRegistrationCleanerSignupTermsRoute
  '/login/$token': typeof consumerAuthLayoutLoginTokenRoute
  '/bookings/$id': typeof consumerAuthenticatedBookingsIdRouteWithChildren
  '/bookings/history': typeof consumerAuthenticatedBookingsHistoryRoute
  '/chats/$id': typeof consumerAuthenticatedChatsIdRoute
  '/my-wallet/add-payment-card': typeof consumerAuthenticatedMyWalletAddPaymentCardRoute
  '/my-wallet/topup-balance': typeof consumerAuthenticatedMyWalletTopupBalanceRoute
  '/bookings': typeof consumerAuthenticatedBookingsIndexRoute
  '/my-wallet': typeof consumerAuthenticatedMyWalletIndexRoute
  '/cleaner/bookings/$id': typeof cleanerAuthenticatedCleanerBookingsIdRoute
  '/cleaner/opportunities/$id': typeof cleanerAuthenticatedCleanerOpportunitiesIdRoute
  '/bookings/$id/payment': typeof consumerAuthenticatedBookingsIdPaymentRoute
  '/my-wallet/withdraw/success': typeof consumerAuthenticatedMyWalletWithdrawSuccessRoute
  '/my-wallet/withdraw': typeof consumerAuthenticatedMyWalletWithdrawIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/landing-page-v1': typeof LandingPageV1Route
  '/landing-page-v2': typeof LandingPageV2Route
  '/onboarding': typeof OnboardingRoute
  '/onboarding-success': typeof OnboardingSuccessRoute
  '/video': typeof VideoRoute
  '/(cleaner)/_auth-layout': typeof cleanerAuthLayoutRouteWithChildren
  '/(cleaner)/_authenticated': typeof cleanerAuthenticatedRouteWithChildren
  '/(cleaner)/_registration': typeof cleanerRegistrationRouteWithChildren
  '/(cleaner)/application-submitted': typeof cleanerApplicationSubmittedRoute
  '/(cleaner)/status-verification': typeof cleanerStatusVerificationRoute
  '/(consumer)/_auth-layout': typeof consumerAuthLayoutRouteWithChildren
  '/(consumer)/_authenticated': typeof consumerAuthenticatedRouteWithChildren
  '/(consumer)/_public': typeof consumerPublicRouteWithChildren
  '/checkr/disclosure-consent-embed': typeof CheckrDisclosureConsentEmbedRoute
  '/embed/signup': typeof EmbedSignupRoute
  '/(cleaner)/apply-cleaner/background-check': typeof cleanerApplyCleanerBackgroundCheckRoute
  '/(cleaner)/apply-cleaner/completed': typeof cleanerApplyCleanerCompletedRoute
  '/(cleaner)/apply-cleaner/personal-info': typeof cleanerApplyCleanerPersonalInfoRoute
  '/(cleaner)/apply-cleaner/signup': typeof cleanerApplyCleanerSignupRoute
  '/(cleaner)/cleaner/contact-us': typeof cleanerCleanerContactUsRoute
  '/(cleaner)/cleaner/faq': typeof cleanerCleanerFaqRoute
  '/(consumer)/(bookings)/booking': typeof consumerbookingsBookingRoute
  '/(consumer)/_auth-layout/login': typeof consumerAuthLayoutLoginRouteWithChildren
  '/(consumer)/_auth-layout/otp': typeof consumerAuthLayoutOtpRoute
  '/(consumer)/_auth-layout/register': typeof consumerAuthLayoutRegisterRoute
  '/(consumer)/_authenticated/dashboard': typeof consumerAuthenticatedDashboardRoute
  '/(consumer)/_authenticated/edit-profile': typeof consumerAuthenticatedEditProfileRoute
  '/(consumer)/_authenticated/favorites': typeof consumerAuthenticatedFavoritesRoute
  '/(consumer)/_authenticated/notifications': typeof consumerAuthenticatedNotificationsRoute
  '/(consumer)/_authenticated/request-delete-account': typeof consumerAuthenticatedRequestDeleteAccountRoute
  '/(consumer)/_authenticated/view-profile': typeof consumerAuthenticatedViewProfileRoute
  '/(consumer)/_public/about-us': typeof consumerPublicAboutUsRoute
  '/(consumer)/_public/contact-us': typeof consumerPublicContactUsRoute
  '/(consumer)/_public/cookie-policy': typeof consumerPublicCookiePolicyRoute
  '/(consumer)/_public/faq': typeof consumerPublicFaqRoute
  '/(consumer)/_public/home': typeof consumerPublicHomeRoute
  '/(consumer)/_public/our-service': typeof consumerPublicOurServiceRoute
  '/(consumer)/_public/privacy-health-data': typeof consumerPublicPrivacyHealthDataRoute
  '/(consumer)/_public/privacy-policy': typeof consumerPublicPrivacyPolicyRoute
  '/(consumer)/_public/terms-of-service': typeof consumerPublicTermsOfServiceRoute
  '/(cleaner)/apply-cleaner/': typeof cleanerApplyCleanerIndexRoute
  '/(cleaner)/_auth-layout/cleaner/login': typeof cleanerAuthLayoutCleanerLoginRoute
  '/(cleaner)/_auth-layout/cleaner/otp': typeof cleanerAuthLayoutCleanerOtpRoute
  '/(cleaner)/_authenticated/cleaner/availability': typeof cleanerAuthenticatedCleanerAvailabilityRoute
  '/(cleaner)/_authenticated/cleaner/booking-details': typeof cleanerAuthenticatedCleanerBookingDetailsRoute
  '/(cleaner)/_authenticated/cleaner/booking-details-request': typeof cleanerAuthenticatedCleanerBookingDetailsRequestRoute
  '/(cleaner)/_authenticated/cleaner/bookings': typeof cleanerAuthenticatedCleanerBookingsRouteWithChildren
  '/(cleaner)/_authenticated/cleaner/dashboard': typeof cleanerAuthenticatedCleanerDashboardRoute
  '/(cleaner)/_authenticated/cleaner/edit-profile': typeof cleanerAuthenticatedCleanerEditProfileRoute
  '/(cleaner)/_authenticated/cleaner/notifications': typeof cleanerAuthenticatedCleanerNotificationsRoute
  '/(cleaner)/_authenticated/cleaner/opportunities': typeof cleanerAuthenticatedCleanerOpportunitiesRouteWithChildren
  '/(cleaner)/_authenticated/cleaner/opportunities-details': typeof cleanerAuthenticatedCleanerOpportunitiesDetailsRoute
  '/(cleaner)/_authenticated/cleaner/payout': typeof cleanerAuthenticatedCleanerPayoutRoute
  '/(cleaner)/_authenticated/cleaner/payout-add-bank-account': typeof cleanerAuthenticatedCleanerPayoutAddBankAccountRoute
  '/(cleaner)/_authenticated/cleaner/payout-edit': typeof cleanerAuthenticatedCleanerPayoutEditRoute
  '/(cleaner)/_authenticated/cleaner/payout-now': typeof cleanerAuthenticatedCleanerPayoutNowRoute
  '/(cleaner)/_authenticated/cleaner/reviews': typeof cleanerAuthenticatedCleanerReviewsRoute
  '/(cleaner)/_authenticated/cleaner/view-profile': typeof cleanerAuthenticatedCleanerViewProfileRoute
  '/(cleaner)/_authenticated/cleaner/work-setup': typeof cleanerAuthenticatedCleanerWorkSetupRoute
  '/(cleaner)/_registration/cleaner/signup-completed': typeof cleanerRegistrationCleanerSignupCompletedRoute
  '/(cleaner)/_registration/cleaner/signup-info': typeof cleanerRegistrationCleanerSignupInfoRoute
  '/(cleaner)/_registration/cleaner/signup-setup': typeof cleanerRegistrationCleanerSignupSetupRoute
  '/(cleaner)/_registration/cleaner/signup-terms': typeof cleanerRegistrationCleanerSignupTermsRoute
  '/(consumer)/_auth-layout/login/$token': typeof consumerAuthLayoutLoginTokenRoute
  '/(consumer)/_authenticated/bookings/$id': typeof consumerAuthenticatedBookingsIdRouteWithChildren
  '/(consumer)/_authenticated/bookings/history': typeof consumerAuthenticatedBookingsHistoryRoute
  '/(consumer)/_authenticated/chats/$id': typeof consumerAuthenticatedChatsIdRoute
  '/(consumer)/_authenticated/my-wallet/add-payment-card': typeof consumerAuthenticatedMyWalletAddPaymentCardRoute
  '/(consumer)/_authenticated/my-wallet/topup-balance': typeof consumerAuthenticatedMyWalletTopupBalanceRoute
  '/(consumer)/_authenticated/my-wallet/withdraw': typeof consumerAuthenticatedMyWalletWithdrawRouteWithChildren
  '/(consumer)/_authenticated/bookings/': typeof consumerAuthenticatedBookingsIndexRoute
  '/(consumer)/_authenticated/my-wallet/': typeof consumerAuthenticatedMyWalletIndexRoute
  '/(cleaner)/_authenticated/cleaner/bookings/$id': typeof cleanerAuthenticatedCleanerBookingsIdRoute
  '/(cleaner)/_authenticated/cleaner/opportunities/$id': typeof cleanerAuthenticatedCleanerOpportunitiesIdRoute
  '/(consumer)/_authenticated/bookings/$id/payment': typeof consumerAuthenticatedBookingsIdPaymentRoute
  '/(consumer)/_authenticated/my-wallet/withdraw/success': typeof consumerAuthenticatedMyWalletWithdrawSuccessRoute
  '/(consumer)/_authenticated/my-wallet/withdraw/': typeof consumerAuthenticatedMyWalletWithdrawIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/landing-page-v1'
    | '/landing-page-v2'
    | '/onboarding'
    | '/onboarding-success'
    | '/video'
    | '/application-submitted'
    | '/status-verification'
    | '/checkr/disclosure-consent-embed'
    | '/embed/signup'
    | '/apply-cleaner/background-check'
    | '/apply-cleaner/completed'
    | '/apply-cleaner/personal-info'
    | '/apply-cleaner/signup'
    | '/cleaner/contact-us'
    | '/cleaner/faq'
    | '/booking'
    | '/login'
    | '/otp'
    | '/register'
    | '/dashboard'
    | '/edit-profile'
    | '/favorites'
    | '/notifications'
    | '/request-delete-account'
    | '/view-profile'
    | '/about-us'
    | '/contact-us'
    | '/cookie-policy'
    | '/faq'
    | '/home'
    | '/our-service'
    | '/privacy-health-data'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/apply-cleaner/'
    | '/cleaner/login'
    | '/cleaner/otp'
    | '/cleaner/availability'
    | '/cleaner/booking-details'
    | '/cleaner/booking-details-request'
    | '/cleaner/bookings'
    | '/cleaner/dashboard'
    | '/cleaner/edit-profile'
    | '/cleaner/notifications'
    | '/cleaner/opportunities'
    | '/cleaner/opportunities-details'
    | '/cleaner/payout'
    | '/cleaner/payout-add-bank-account'
    | '/cleaner/payout-edit'
    | '/cleaner/payout-now'
    | '/cleaner/reviews'
    | '/cleaner/view-profile'
    | '/cleaner/work-setup'
    | '/cleaner/signup-completed'
    | '/cleaner/signup-info'
    | '/cleaner/signup-setup'
    | '/cleaner/signup-terms'
    | '/login/$token'
    | '/bookings/$id'
    | '/bookings/history'
    | '/chats/$id'
    | '/my-wallet/add-payment-card'
    | '/my-wallet/topup-balance'
    | '/my-wallet/withdraw'
    | '/bookings/'
    | '/my-wallet/'
    | '/cleaner/bookings/$id'
    | '/cleaner/opportunities/$id'
    | '/bookings/$id/payment'
    | '/my-wallet/withdraw/success'
    | '/my-wallet/withdraw/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/landing-page-v1'
    | '/landing-page-v2'
    | '/onboarding'
    | '/onboarding-success'
    | '/video'
    | '/application-submitted'
    | '/status-verification'
    | '/checkr/disclosure-consent-embed'
    | '/embed/signup'
    | '/apply-cleaner/background-check'
    | '/apply-cleaner/completed'
    | '/apply-cleaner/personal-info'
    | '/apply-cleaner/signup'
    | '/cleaner/contact-us'
    | '/cleaner/faq'
    | '/booking'
    | '/login'
    | '/otp'
    | '/register'
    | '/dashboard'
    | '/edit-profile'
    | '/favorites'
    | '/notifications'
    | '/request-delete-account'
    | '/view-profile'
    | '/about-us'
    | '/contact-us'
    | '/cookie-policy'
    | '/faq'
    | '/home'
    | '/our-service'
    | '/privacy-health-data'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/apply-cleaner'
    | '/cleaner/login'
    | '/cleaner/otp'
    | '/cleaner/availability'
    | '/cleaner/booking-details'
    | '/cleaner/booking-details-request'
    | '/cleaner/bookings'
    | '/cleaner/dashboard'
    | '/cleaner/edit-profile'
    | '/cleaner/notifications'
    | '/cleaner/opportunities'
    | '/cleaner/opportunities-details'
    | '/cleaner/payout'
    | '/cleaner/payout-add-bank-account'
    | '/cleaner/payout-edit'
    | '/cleaner/payout-now'
    | '/cleaner/reviews'
    | '/cleaner/view-profile'
    | '/cleaner/work-setup'
    | '/cleaner/signup-completed'
    | '/cleaner/signup-info'
    | '/cleaner/signup-setup'
    | '/cleaner/signup-terms'
    | '/login/$token'
    | '/bookings/$id'
    | '/bookings/history'
    | '/chats/$id'
    | '/my-wallet/add-payment-card'
    | '/my-wallet/topup-balance'
    | '/bookings'
    | '/my-wallet'
    | '/cleaner/bookings/$id'
    | '/cleaner/opportunities/$id'
    | '/bookings/$id/payment'
    | '/my-wallet/withdraw/success'
    | '/my-wallet/withdraw'
  id:
    | '__root__'
    | '/'
    | '/landing-page-v1'
    | '/landing-page-v2'
    | '/onboarding'
    | '/onboarding-success'
    | '/video'
    | '/(cleaner)/_auth-layout'
    | '/(cleaner)/_authenticated'
    | '/(cleaner)/_registration'
    | '/(cleaner)/application-submitted'
    | '/(cleaner)/status-verification'
    | '/(consumer)/_auth-layout'
    | '/(consumer)/_authenticated'
    | '/(consumer)/_public'
    | '/checkr/disclosure-consent-embed'
    | '/embed/signup'
    | '/(cleaner)/apply-cleaner/background-check'
    | '/(cleaner)/apply-cleaner/completed'
    | '/(cleaner)/apply-cleaner/personal-info'
    | '/(cleaner)/apply-cleaner/signup'
    | '/(cleaner)/cleaner/contact-us'
    | '/(cleaner)/cleaner/faq'
    | '/(consumer)/(bookings)/booking'
    | '/(consumer)/_auth-layout/login'
    | '/(consumer)/_auth-layout/otp'
    | '/(consumer)/_auth-layout/register'
    | '/(consumer)/_authenticated/dashboard'
    | '/(consumer)/_authenticated/edit-profile'
    | '/(consumer)/_authenticated/favorites'
    | '/(consumer)/_authenticated/notifications'
    | '/(consumer)/_authenticated/request-delete-account'
    | '/(consumer)/_authenticated/view-profile'
    | '/(consumer)/_public/about-us'
    | '/(consumer)/_public/contact-us'
    | '/(consumer)/_public/cookie-policy'
    | '/(consumer)/_public/faq'
    | '/(consumer)/_public/home'
    | '/(consumer)/_public/our-service'
    | '/(consumer)/_public/privacy-health-data'
    | '/(consumer)/_public/privacy-policy'
    | '/(consumer)/_public/terms-of-service'
    | '/(cleaner)/apply-cleaner/'
    | '/(cleaner)/_auth-layout/cleaner/login'
    | '/(cleaner)/_auth-layout/cleaner/otp'
    | '/(cleaner)/_authenticated/cleaner/availability'
    | '/(cleaner)/_authenticated/cleaner/booking-details'
    | '/(cleaner)/_authenticated/cleaner/booking-details-request'
    | '/(cleaner)/_authenticated/cleaner/bookings'
    | '/(cleaner)/_authenticated/cleaner/dashboard'
    | '/(cleaner)/_authenticated/cleaner/edit-profile'
    | '/(cleaner)/_authenticated/cleaner/notifications'
    | '/(cleaner)/_authenticated/cleaner/opportunities'
    | '/(cleaner)/_authenticated/cleaner/opportunities-details'
    | '/(cleaner)/_authenticated/cleaner/payout'
    | '/(cleaner)/_authenticated/cleaner/payout-add-bank-account'
    | '/(cleaner)/_authenticated/cleaner/payout-edit'
    | '/(cleaner)/_authenticated/cleaner/payout-now'
    | '/(cleaner)/_authenticated/cleaner/reviews'
    | '/(cleaner)/_authenticated/cleaner/view-profile'
    | '/(cleaner)/_authenticated/cleaner/work-setup'
    | '/(cleaner)/_registration/cleaner/signup-completed'
    | '/(cleaner)/_registration/cleaner/signup-info'
    | '/(cleaner)/_registration/cleaner/signup-setup'
    | '/(cleaner)/_registration/cleaner/signup-terms'
    | '/(consumer)/_auth-layout/login/$token'
    | '/(consumer)/_authenticated/bookings/$id'
    | '/(consumer)/_authenticated/bookings/history'
    | '/(consumer)/_authenticated/chats/$id'
    | '/(consumer)/_authenticated/my-wallet/add-payment-card'
    | '/(consumer)/_authenticated/my-wallet/topup-balance'
    | '/(consumer)/_authenticated/my-wallet/withdraw'
    | '/(consumer)/_authenticated/bookings/'
    | '/(consumer)/_authenticated/my-wallet/'
    | '/(cleaner)/_authenticated/cleaner/bookings/$id'
    | '/(cleaner)/_authenticated/cleaner/opportunities/$id'
    | '/(consumer)/_authenticated/bookings/$id/payment'
    | '/(consumer)/_authenticated/my-wallet/withdraw/success'
    | '/(consumer)/_authenticated/my-wallet/withdraw/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LandingPageV1Route: typeof LandingPageV1Route
  LandingPageV2Route: typeof LandingPageV2Route
  OnboardingRoute: typeof OnboardingRoute
  OnboardingSuccessRoute: typeof OnboardingSuccessRoute
  VideoRoute: typeof VideoRoute
  cleanerAuthLayoutRoute: typeof cleanerAuthLayoutRouteWithChildren
  cleanerAuthenticatedRoute: typeof cleanerAuthenticatedRouteWithChildren
  cleanerRegistrationRoute: typeof cleanerRegistrationRouteWithChildren
  cleanerApplicationSubmittedRoute: typeof cleanerApplicationSubmittedRoute
  cleanerStatusVerificationRoute: typeof cleanerStatusVerificationRoute
  consumerAuthLayoutRoute: typeof consumerAuthLayoutRouteWithChildren
  consumerAuthenticatedRoute: typeof consumerAuthenticatedRouteWithChildren
  consumerPublicRoute: typeof consumerPublicRouteWithChildren
  CheckrDisclosureConsentEmbedRoute: typeof CheckrDisclosureConsentEmbedRoute
  EmbedSignupRoute: typeof EmbedSignupRoute
  cleanerApplyCleanerBackgroundCheckRoute: typeof cleanerApplyCleanerBackgroundCheckRoute
  cleanerApplyCleanerCompletedRoute: typeof cleanerApplyCleanerCompletedRoute
  cleanerApplyCleanerPersonalInfoRoute: typeof cleanerApplyCleanerPersonalInfoRoute
  cleanerApplyCleanerSignupRoute: typeof cleanerApplyCleanerSignupRoute
  cleanerCleanerContactUsRoute: typeof cleanerCleanerContactUsRoute
  cleanerCleanerFaqRoute: typeof cleanerCleanerFaqRoute
  consumerbookingsBookingRoute: typeof consumerbookingsBookingRoute
  cleanerApplyCleanerIndexRoute: typeof cleanerApplyCleanerIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing-page-v1': {
      id: '/landing-page-v1'
      path: '/landing-page-v1'
      fullPath: '/landing-page-v1'
      preLoaderRoute: typeof LandingPageV1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing-page-v2': {
      id: '/landing-page-v2'
      path: '/landing-page-v2'
      fullPath: '/landing-page-v2'
      preLoaderRoute: typeof LandingPageV2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding-success': {
      id: '/onboarding-success'
      path: '/onboarding-success'
      fullPath: '/onboarding-success'
      preLoaderRoute: typeof OnboardingSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video': {
      id: '/video'
      path: '/video'
      fullPath: '/video'
      preLoaderRoute: typeof VideoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/_auth-layout': {
      id: '/(cleaner)/_auth-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof cleanerAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/_authenticated': {
      id: '/(cleaner)/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof cleanerAuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/_registration': {
      id: '/(cleaner)/_registration'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof cleanerRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/application-submitted': {
      id: '/(cleaner)/application-submitted'
      path: '/application-submitted'
      fullPath: '/application-submitted'
      preLoaderRoute: typeof cleanerApplicationSubmittedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/status-verification': {
      id: '/(cleaner)/status-verification'
      path: '/status-verification'
      fullPath: '/status-verification'
      preLoaderRoute: typeof cleanerStatusVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(consumer)/_auth-layout': {
      id: '/(consumer)/_auth-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof consumerAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(consumer)/_authenticated': {
      id: '/(consumer)/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof consumerAuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(consumer)/_public': {
      id: '/(consumer)/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof consumerPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkr/disclosure-consent-embed': {
      id: '/checkr/disclosure-consent-embed'
      path: '/checkr/disclosure-consent-embed'
      fullPath: '/checkr/disclosure-consent-embed'
      preLoaderRoute: typeof CheckrDisclosureConsentEmbedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/signup': {
      id: '/embed/signup'
      path: '/embed/signup'
      fullPath: '/embed/signup'
      preLoaderRoute: typeof EmbedSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/apply-cleaner/': {
      id: '/(cleaner)/apply-cleaner/'
      path: '/apply-cleaner'
      fullPath: '/apply-cleaner/'
      preLoaderRoute: typeof cleanerApplyCleanerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/apply-cleaner/background-check': {
      id: '/(cleaner)/apply-cleaner/background-check'
      path: '/apply-cleaner/background-check'
      fullPath: '/apply-cleaner/background-check'
      preLoaderRoute: typeof cleanerApplyCleanerBackgroundCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/apply-cleaner/completed': {
      id: '/(cleaner)/apply-cleaner/completed'
      path: '/apply-cleaner/completed'
      fullPath: '/apply-cleaner/completed'
      preLoaderRoute: typeof cleanerApplyCleanerCompletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/apply-cleaner/personal-info': {
      id: '/(cleaner)/apply-cleaner/personal-info'
      path: '/apply-cleaner/personal-info'
      fullPath: '/apply-cleaner/personal-info'
      preLoaderRoute: typeof cleanerApplyCleanerPersonalInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/apply-cleaner/signup': {
      id: '/(cleaner)/apply-cleaner/signup'
      path: '/apply-cleaner/signup'
      fullPath: '/apply-cleaner/signup'
      preLoaderRoute: typeof cleanerApplyCleanerSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/cleaner/contact-us': {
      id: '/(cleaner)/cleaner/contact-us'
      path: '/cleaner/contact-us'
      fullPath: '/cleaner/contact-us'
      preLoaderRoute: typeof cleanerCleanerContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(cleaner)/cleaner/faq': {
      id: '/(cleaner)/cleaner/faq'
      path: '/cleaner/faq'
      fullPath: '/cleaner/faq'
      preLoaderRoute: typeof cleanerCleanerFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(consumer)/(bookings)/booking': {
      id: '/(consumer)/(bookings)/booking'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof consumerbookingsBookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(consumer)/_auth-layout/login': {
      id: '/(consumer)/_auth-layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof consumerAuthLayoutLoginRouteImport
      parentRoute: typeof consumerAuthLayoutRoute
    }
    '/(consumer)/_auth-layout/otp': {
      id: '/(consumer)/_auth-layout/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof consumerAuthLayoutOtpRouteImport
      parentRoute: typeof consumerAuthLayoutRoute
    }
    '/(consumer)/_auth-layout/register': {
      id: '/(consumer)/_auth-layout/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof consumerAuthLayoutRegisterRouteImport
      parentRoute: typeof consumerAuthLayoutRoute
    }
    '/(consumer)/_authenticated/dashboard': {
      id: '/(consumer)/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof consumerAuthenticatedDashboardRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/edit-profile': {
      id: '/(consumer)/_authenticated/edit-profile'
      path: '/edit-profile'
      fullPath: '/edit-profile'
      preLoaderRoute: typeof consumerAuthenticatedEditProfileRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/favorites': {
      id: '/(consumer)/_authenticated/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof consumerAuthenticatedFavoritesRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/notifications': {
      id: '/(consumer)/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof consumerAuthenticatedNotificationsRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/request-delete-account': {
      id: '/(consumer)/_authenticated/request-delete-account'
      path: '/request-delete-account'
      fullPath: '/request-delete-account'
      preLoaderRoute: typeof consumerAuthenticatedRequestDeleteAccountRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/view-profile': {
      id: '/(consumer)/_authenticated/view-profile'
      path: '/view-profile'
      fullPath: '/view-profile'
      preLoaderRoute: typeof consumerAuthenticatedViewProfileRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_public/about-us': {
      id: '/(consumer)/_public/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof consumerPublicAboutUsRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/contact-us': {
      id: '/(consumer)/_public/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof consumerPublicContactUsRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/cookie-policy': {
      id: '/(consumer)/_public/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof consumerPublicCookiePolicyRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/faq': {
      id: '/(consumer)/_public/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof consumerPublicFaqRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/home': {
      id: '/(consumer)/_public/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof consumerPublicHomeRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/our-service': {
      id: '/(consumer)/_public/our-service'
      path: '/our-service'
      fullPath: '/our-service'
      preLoaderRoute: typeof consumerPublicOurServiceRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/privacy-health-data': {
      id: '/(consumer)/_public/privacy-health-data'
      path: '/privacy-health-data'
      fullPath: '/privacy-health-data'
      preLoaderRoute: typeof consumerPublicPrivacyHealthDataRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/privacy-policy': {
      id: '/(consumer)/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof consumerPublicPrivacyPolicyRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(consumer)/_public/terms-of-service': {
      id: '/(consumer)/_public/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof consumerPublicTermsOfServiceRouteImport
      parentRoute: typeof consumerPublicRoute
    }
    '/(cleaner)/_auth-layout/cleaner/login': {
      id: '/(cleaner)/_auth-layout/cleaner/login'
      path: '/cleaner/login'
      fullPath: '/cleaner/login'
      preLoaderRoute: typeof cleanerAuthLayoutCleanerLoginRouteImport
      parentRoute: typeof cleanerAuthLayoutRoute
    }
    '/(cleaner)/_auth-layout/cleaner/otp': {
      id: '/(cleaner)/_auth-layout/cleaner/otp'
      path: '/cleaner/otp'
      fullPath: '/cleaner/otp'
      preLoaderRoute: typeof cleanerAuthLayoutCleanerOtpRouteImport
      parentRoute: typeof cleanerAuthLayoutRoute
    }
    '/(cleaner)/_authenticated/cleaner/availability': {
      id: '/(cleaner)/_authenticated/cleaner/availability'
      path: '/cleaner/availability'
      fullPath: '/cleaner/availability'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerAvailabilityRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/booking-details': {
      id: '/(cleaner)/_authenticated/cleaner/booking-details'
      path: '/cleaner/booking-details'
      fullPath: '/cleaner/booking-details'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerBookingDetailsRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/booking-details-request': {
      id: '/(cleaner)/_authenticated/cleaner/booking-details-request'
      path: '/cleaner/booking-details-request'
      fullPath: '/cleaner/booking-details-request'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerBookingDetailsRequestRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/bookings': {
      id: '/(cleaner)/_authenticated/cleaner/bookings'
      path: '/cleaner/bookings'
      fullPath: '/cleaner/bookings'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerBookingsRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/dashboard': {
      id: '/(cleaner)/_authenticated/cleaner/dashboard'
      path: '/cleaner/dashboard'
      fullPath: '/cleaner/dashboard'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerDashboardRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/edit-profile': {
      id: '/(cleaner)/_authenticated/cleaner/edit-profile'
      path: '/cleaner/edit-profile'
      fullPath: '/cleaner/edit-profile'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerEditProfileRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/notifications': {
      id: '/(cleaner)/_authenticated/cleaner/notifications'
      path: '/cleaner/notifications'
      fullPath: '/cleaner/notifications'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerNotificationsRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/opportunities': {
      id: '/(cleaner)/_authenticated/cleaner/opportunities'
      path: '/cleaner/opportunities'
      fullPath: '/cleaner/opportunities'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerOpportunitiesRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/opportunities-details': {
      id: '/(cleaner)/_authenticated/cleaner/opportunities-details'
      path: '/cleaner/opportunities-details'
      fullPath: '/cleaner/opportunities-details'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerOpportunitiesDetailsRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/payout': {
      id: '/(cleaner)/_authenticated/cleaner/payout'
      path: '/cleaner/payout'
      fullPath: '/cleaner/payout'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerPayoutRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/payout-add-bank-account': {
      id: '/(cleaner)/_authenticated/cleaner/payout-add-bank-account'
      path: '/cleaner/payout-add-bank-account'
      fullPath: '/cleaner/payout-add-bank-account'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerPayoutAddBankAccountRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/payout-edit': {
      id: '/(cleaner)/_authenticated/cleaner/payout-edit'
      path: '/cleaner/payout-edit'
      fullPath: '/cleaner/payout-edit'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerPayoutEditRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/payout-now': {
      id: '/(cleaner)/_authenticated/cleaner/payout-now'
      path: '/cleaner/payout-now'
      fullPath: '/cleaner/payout-now'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerPayoutNowRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/reviews': {
      id: '/(cleaner)/_authenticated/cleaner/reviews'
      path: '/cleaner/reviews'
      fullPath: '/cleaner/reviews'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerReviewsRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/view-profile': {
      id: '/(cleaner)/_authenticated/cleaner/view-profile'
      path: '/cleaner/view-profile'
      fullPath: '/cleaner/view-profile'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerViewProfileRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/work-setup': {
      id: '/(cleaner)/_authenticated/cleaner/work-setup'
      path: '/cleaner/work-setup'
      fullPath: '/cleaner/work-setup'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerWorkSetupRouteImport
      parentRoute: typeof cleanerAuthenticatedRoute
    }
    '/(cleaner)/_registration/cleaner/signup-completed': {
      id: '/(cleaner)/_registration/cleaner/signup-completed'
      path: '/cleaner/signup-completed'
      fullPath: '/cleaner/signup-completed'
      preLoaderRoute: typeof cleanerRegistrationCleanerSignupCompletedRouteImport
      parentRoute: typeof cleanerRegistrationRoute
    }
    '/(cleaner)/_registration/cleaner/signup-info': {
      id: '/(cleaner)/_registration/cleaner/signup-info'
      path: '/cleaner/signup-info'
      fullPath: '/cleaner/signup-info'
      preLoaderRoute: typeof cleanerRegistrationCleanerSignupInfoRouteImport
      parentRoute: typeof cleanerRegistrationRoute
    }
    '/(cleaner)/_registration/cleaner/signup-setup': {
      id: '/(cleaner)/_registration/cleaner/signup-setup'
      path: '/cleaner/signup-setup'
      fullPath: '/cleaner/signup-setup'
      preLoaderRoute: typeof cleanerRegistrationCleanerSignupSetupRouteImport
      parentRoute: typeof cleanerRegistrationRoute
    }
    '/(cleaner)/_registration/cleaner/signup-terms': {
      id: '/(cleaner)/_registration/cleaner/signup-terms'
      path: '/cleaner/signup-terms'
      fullPath: '/cleaner/signup-terms'
      preLoaderRoute: typeof cleanerRegistrationCleanerSignupTermsRouteImport
      parentRoute: typeof cleanerRegistrationRoute
    }
    '/(consumer)/_auth-layout/login/$token': {
      id: '/(consumer)/_auth-layout/login/$token'
      path: '/$token'
      fullPath: '/login/$token'
      preLoaderRoute: typeof consumerAuthLayoutLoginTokenRouteImport
      parentRoute: typeof consumerAuthLayoutLoginRoute
    }
    '/(consumer)/_authenticated/bookings/': {
      id: '/(consumer)/_authenticated/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof consumerAuthenticatedBookingsIndexRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/bookings/$id': {
      id: '/(consumer)/_authenticated/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof consumerAuthenticatedBookingsIdRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/bookings/history': {
      id: '/(consumer)/_authenticated/bookings/history'
      path: '/bookings/history'
      fullPath: '/bookings/history'
      preLoaderRoute: typeof consumerAuthenticatedBookingsHistoryRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/chats/$id': {
      id: '/(consumer)/_authenticated/chats/$id'
      path: '/chats/$id'
      fullPath: '/chats/$id'
      preLoaderRoute: typeof consumerAuthenticatedChatsIdRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/my-wallet/': {
      id: '/(consumer)/_authenticated/my-wallet/'
      path: '/my-wallet'
      fullPath: '/my-wallet/'
      preLoaderRoute: typeof consumerAuthenticatedMyWalletIndexRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/my-wallet/add-payment-card': {
      id: '/(consumer)/_authenticated/my-wallet/add-payment-card'
      path: '/my-wallet/add-payment-card'
      fullPath: '/my-wallet/add-payment-card'
      preLoaderRoute: typeof consumerAuthenticatedMyWalletAddPaymentCardRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/my-wallet/topup-balance': {
      id: '/(consumer)/_authenticated/my-wallet/topup-balance'
      path: '/my-wallet/topup-balance'
      fullPath: '/my-wallet/topup-balance'
      preLoaderRoute: typeof consumerAuthenticatedMyWalletTopupBalanceRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(consumer)/_authenticated/my-wallet/withdraw': {
      id: '/(consumer)/_authenticated/my-wallet/withdraw'
      path: '/my-wallet/withdraw'
      fullPath: '/my-wallet/withdraw'
      preLoaderRoute: typeof consumerAuthenticatedMyWalletWithdrawRouteImport
      parentRoute: typeof consumerAuthenticatedRoute
    }
    '/(cleaner)/_authenticated/cleaner/bookings/$id': {
      id: '/(cleaner)/_authenticated/cleaner/bookings/$id'
      path: '/$id'
      fullPath: '/cleaner/bookings/$id'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerBookingsIdRouteImport
      parentRoute: typeof cleanerAuthenticatedCleanerBookingsRoute
    }
    '/(cleaner)/_authenticated/cleaner/opportunities/$id': {
      id: '/(cleaner)/_authenticated/cleaner/opportunities/$id'
      path: '/$id'
      fullPath: '/cleaner/opportunities/$id'
      preLoaderRoute: typeof cleanerAuthenticatedCleanerOpportunitiesIdRouteImport
      parentRoute: typeof cleanerAuthenticatedCleanerOpportunitiesRoute
    }
    '/(consumer)/_authenticated/bookings/$id/payment': {
      id: '/(consumer)/_authenticated/bookings/$id/payment'
      path: '/payment'
      fullPath: '/bookings/$id/payment'
      preLoaderRoute: typeof consumerAuthenticatedBookingsIdPaymentRouteImport
      parentRoute: typeof consumerAuthenticatedBookingsIdRoute
    }
    '/(consumer)/_authenticated/my-wallet/withdraw/': {
      id: '/(consumer)/_authenticated/my-wallet/withdraw/'
      path: '/'
      fullPath: '/my-wallet/withdraw/'
      preLoaderRoute: typeof consumerAuthenticatedMyWalletWithdrawIndexRouteImport
      parentRoute: typeof consumerAuthenticatedMyWalletWithdrawRoute
    }
    '/(consumer)/_authenticated/my-wallet/withdraw/success': {
      id: '/(consumer)/_authenticated/my-wallet/withdraw/success'
      path: '/success'
      fullPath: '/my-wallet/withdraw/success'
      preLoaderRoute: typeof consumerAuthenticatedMyWalletWithdrawSuccessRouteImport
      parentRoute: typeof consumerAuthenticatedMyWalletWithdrawRoute
    }
  }
}

interface cleanerAuthLayoutRouteChildren {
  cleanerAuthLayoutCleanerLoginRoute: typeof cleanerAuthLayoutCleanerLoginRoute
  cleanerAuthLayoutCleanerOtpRoute: typeof cleanerAuthLayoutCleanerOtpRoute
}

const cleanerAuthLayoutRouteChildren: cleanerAuthLayoutRouteChildren = {
  cleanerAuthLayoutCleanerLoginRoute: cleanerAuthLayoutCleanerLoginRoute,
  cleanerAuthLayoutCleanerOtpRoute: cleanerAuthLayoutCleanerOtpRoute,
}

const cleanerAuthLayoutRouteWithChildren =
  cleanerAuthLayoutRoute._addFileChildren(cleanerAuthLayoutRouteChildren)

interface cleanerAuthenticatedCleanerBookingsRouteChildren {
  cleanerAuthenticatedCleanerBookingsIdRoute: typeof cleanerAuthenticatedCleanerBookingsIdRoute
}

const cleanerAuthenticatedCleanerBookingsRouteChildren: cleanerAuthenticatedCleanerBookingsRouteChildren =
  {
    cleanerAuthenticatedCleanerBookingsIdRoute:
      cleanerAuthenticatedCleanerBookingsIdRoute,
  }

const cleanerAuthenticatedCleanerBookingsRouteWithChildren =
  cleanerAuthenticatedCleanerBookingsRoute._addFileChildren(
    cleanerAuthenticatedCleanerBookingsRouteChildren,
  )

interface cleanerAuthenticatedCleanerOpportunitiesRouteChildren {
  cleanerAuthenticatedCleanerOpportunitiesIdRoute: typeof cleanerAuthenticatedCleanerOpportunitiesIdRoute
}

const cleanerAuthenticatedCleanerOpportunitiesRouteChildren: cleanerAuthenticatedCleanerOpportunitiesRouteChildren =
  {
    cleanerAuthenticatedCleanerOpportunitiesIdRoute:
      cleanerAuthenticatedCleanerOpportunitiesIdRoute,
  }

const cleanerAuthenticatedCleanerOpportunitiesRouteWithChildren =
  cleanerAuthenticatedCleanerOpportunitiesRoute._addFileChildren(
    cleanerAuthenticatedCleanerOpportunitiesRouteChildren,
  )

interface cleanerAuthenticatedRouteChildren {
  cleanerAuthenticatedCleanerAvailabilityRoute: typeof cleanerAuthenticatedCleanerAvailabilityRoute
  cleanerAuthenticatedCleanerBookingDetailsRoute: typeof cleanerAuthenticatedCleanerBookingDetailsRoute
  cleanerAuthenticatedCleanerBookingDetailsRequestRoute: typeof cleanerAuthenticatedCleanerBookingDetailsRequestRoute
  cleanerAuthenticatedCleanerBookingsRoute: typeof cleanerAuthenticatedCleanerBookingsRouteWithChildren
  cleanerAuthenticatedCleanerDashboardRoute: typeof cleanerAuthenticatedCleanerDashboardRoute
  cleanerAuthenticatedCleanerEditProfileRoute: typeof cleanerAuthenticatedCleanerEditProfileRoute
  cleanerAuthenticatedCleanerNotificationsRoute: typeof cleanerAuthenticatedCleanerNotificationsRoute
  cleanerAuthenticatedCleanerOpportunitiesRoute: typeof cleanerAuthenticatedCleanerOpportunitiesRouteWithChildren
  cleanerAuthenticatedCleanerOpportunitiesDetailsRoute: typeof cleanerAuthenticatedCleanerOpportunitiesDetailsRoute
  cleanerAuthenticatedCleanerPayoutRoute: typeof cleanerAuthenticatedCleanerPayoutRoute
  cleanerAuthenticatedCleanerPayoutAddBankAccountRoute: typeof cleanerAuthenticatedCleanerPayoutAddBankAccountRoute
  cleanerAuthenticatedCleanerPayoutEditRoute: typeof cleanerAuthenticatedCleanerPayoutEditRoute
  cleanerAuthenticatedCleanerPayoutNowRoute: typeof cleanerAuthenticatedCleanerPayoutNowRoute
  cleanerAuthenticatedCleanerReviewsRoute: typeof cleanerAuthenticatedCleanerReviewsRoute
  cleanerAuthenticatedCleanerViewProfileRoute: typeof cleanerAuthenticatedCleanerViewProfileRoute
  cleanerAuthenticatedCleanerWorkSetupRoute: typeof cleanerAuthenticatedCleanerWorkSetupRoute
}

const cleanerAuthenticatedRouteChildren: cleanerAuthenticatedRouteChildren = {
  cleanerAuthenticatedCleanerAvailabilityRoute:
    cleanerAuthenticatedCleanerAvailabilityRoute,
  cleanerAuthenticatedCleanerBookingDetailsRoute:
    cleanerAuthenticatedCleanerBookingDetailsRoute,
  cleanerAuthenticatedCleanerBookingDetailsRequestRoute:
    cleanerAuthenticatedCleanerBookingDetailsRequestRoute,
  cleanerAuthenticatedCleanerBookingsRoute:
    cleanerAuthenticatedCleanerBookingsRouteWithChildren,
  cleanerAuthenticatedCleanerDashboardRoute:
    cleanerAuthenticatedCleanerDashboardRoute,
  cleanerAuthenticatedCleanerEditProfileRoute:
    cleanerAuthenticatedCleanerEditProfileRoute,
  cleanerAuthenticatedCleanerNotificationsRoute:
    cleanerAuthenticatedCleanerNotificationsRoute,
  cleanerAuthenticatedCleanerOpportunitiesRoute:
    cleanerAuthenticatedCleanerOpportunitiesRouteWithChildren,
  cleanerAuthenticatedCleanerOpportunitiesDetailsRoute:
    cleanerAuthenticatedCleanerOpportunitiesDetailsRoute,
  cleanerAuthenticatedCleanerPayoutRoute:
    cleanerAuthenticatedCleanerPayoutRoute,
  cleanerAuthenticatedCleanerPayoutAddBankAccountRoute:
    cleanerAuthenticatedCleanerPayoutAddBankAccountRoute,
  cleanerAuthenticatedCleanerPayoutEditRoute:
    cleanerAuthenticatedCleanerPayoutEditRoute,
  cleanerAuthenticatedCleanerPayoutNowRoute:
    cleanerAuthenticatedCleanerPayoutNowRoute,
  cleanerAuthenticatedCleanerReviewsRoute:
    cleanerAuthenticatedCleanerReviewsRoute,
  cleanerAuthenticatedCleanerViewProfileRoute:
    cleanerAuthenticatedCleanerViewProfileRoute,
  cleanerAuthenticatedCleanerWorkSetupRoute:
    cleanerAuthenticatedCleanerWorkSetupRoute,
}

const cleanerAuthenticatedRouteWithChildren =
  cleanerAuthenticatedRoute._addFileChildren(cleanerAuthenticatedRouteChildren)

interface cleanerRegistrationRouteChildren {
  cleanerRegistrationCleanerSignupCompletedRoute: typeof cleanerRegistrationCleanerSignupCompletedRoute
  cleanerRegistrationCleanerSignupInfoRoute: typeof cleanerRegistrationCleanerSignupInfoRoute
  cleanerRegistrationCleanerSignupSetupRoute: typeof cleanerRegistrationCleanerSignupSetupRoute
  cleanerRegistrationCleanerSignupTermsRoute: typeof cleanerRegistrationCleanerSignupTermsRoute
}

const cleanerRegistrationRouteChildren: cleanerRegistrationRouteChildren = {
  cleanerRegistrationCleanerSignupCompletedRoute:
    cleanerRegistrationCleanerSignupCompletedRoute,
  cleanerRegistrationCleanerSignupInfoRoute:
    cleanerRegistrationCleanerSignupInfoRoute,
  cleanerRegistrationCleanerSignupSetupRoute:
    cleanerRegistrationCleanerSignupSetupRoute,
  cleanerRegistrationCleanerSignupTermsRoute:
    cleanerRegistrationCleanerSignupTermsRoute,
}

const cleanerRegistrationRouteWithChildren =
  cleanerRegistrationRoute._addFileChildren(cleanerRegistrationRouteChildren)

interface consumerAuthLayoutLoginRouteChildren {
  consumerAuthLayoutLoginTokenRoute: typeof consumerAuthLayoutLoginTokenRoute
}

const consumerAuthLayoutLoginRouteChildren: consumerAuthLayoutLoginRouteChildren =
  {
    consumerAuthLayoutLoginTokenRoute: consumerAuthLayoutLoginTokenRoute,
  }

const consumerAuthLayoutLoginRouteWithChildren =
  consumerAuthLayoutLoginRoute._addFileChildren(
    consumerAuthLayoutLoginRouteChildren,
  )

interface consumerAuthLayoutRouteChildren {
  consumerAuthLayoutLoginRoute: typeof consumerAuthLayoutLoginRouteWithChildren
  consumerAuthLayoutOtpRoute: typeof consumerAuthLayoutOtpRoute
  consumerAuthLayoutRegisterRoute: typeof consumerAuthLayoutRegisterRoute
}

const consumerAuthLayoutRouteChildren: consumerAuthLayoutRouteChildren = {
  consumerAuthLayoutLoginRoute: consumerAuthLayoutLoginRouteWithChildren,
  consumerAuthLayoutOtpRoute: consumerAuthLayoutOtpRoute,
  consumerAuthLayoutRegisterRoute: consumerAuthLayoutRegisterRoute,
}

const consumerAuthLayoutRouteWithChildren =
  consumerAuthLayoutRoute._addFileChildren(consumerAuthLayoutRouteChildren)

interface consumerAuthenticatedBookingsIdRouteChildren {
  consumerAuthenticatedBookingsIdPaymentRoute: typeof consumerAuthenticatedBookingsIdPaymentRoute
}

const consumerAuthenticatedBookingsIdRouteChildren: consumerAuthenticatedBookingsIdRouteChildren =
  {
    consumerAuthenticatedBookingsIdPaymentRoute:
      consumerAuthenticatedBookingsIdPaymentRoute,
  }

const consumerAuthenticatedBookingsIdRouteWithChildren =
  consumerAuthenticatedBookingsIdRoute._addFileChildren(
    consumerAuthenticatedBookingsIdRouteChildren,
  )

interface consumerAuthenticatedMyWalletWithdrawRouteChildren {
  consumerAuthenticatedMyWalletWithdrawSuccessRoute: typeof consumerAuthenticatedMyWalletWithdrawSuccessRoute
  consumerAuthenticatedMyWalletWithdrawIndexRoute: typeof consumerAuthenticatedMyWalletWithdrawIndexRoute
}

const consumerAuthenticatedMyWalletWithdrawRouteChildren: consumerAuthenticatedMyWalletWithdrawRouteChildren =
  {
    consumerAuthenticatedMyWalletWithdrawSuccessRoute:
      consumerAuthenticatedMyWalletWithdrawSuccessRoute,
    consumerAuthenticatedMyWalletWithdrawIndexRoute:
      consumerAuthenticatedMyWalletWithdrawIndexRoute,
  }

const consumerAuthenticatedMyWalletWithdrawRouteWithChildren =
  consumerAuthenticatedMyWalletWithdrawRoute._addFileChildren(
    consumerAuthenticatedMyWalletWithdrawRouteChildren,
  )

interface consumerAuthenticatedRouteChildren {
  consumerAuthenticatedDashboardRoute: typeof consumerAuthenticatedDashboardRoute
  consumerAuthenticatedEditProfileRoute: typeof consumerAuthenticatedEditProfileRoute
  consumerAuthenticatedFavoritesRoute: typeof consumerAuthenticatedFavoritesRoute
  consumerAuthenticatedNotificationsRoute: typeof consumerAuthenticatedNotificationsRoute
  consumerAuthenticatedRequestDeleteAccountRoute: typeof consumerAuthenticatedRequestDeleteAccountRoute
  consumerAuthenticatedViewProfileRoute: typeof consumerAuthenticatedViewProfileRoute
  consumerAuthenticatedBookingsIdRoute: typeof consumerAuthenticatedBookingsIdRouteWithChildren
  consumerAuthenticatedBookingsHistoryRoute: typeof consumerAuthenticatedBookingsHistoryRoute
  consumerAuthenticatedChatsIdRoute: typeof consumerAuthenticatedChatsIdRoute
  consumerAuthenticatedMyWalletAddPaymentCardRoute: typeof consumerAuthenticatedMyWalletAddPaymentCardRoute
  consumerAuthenticatedMyWalletTopupBalanceRoute: typeof consumerAuthenticatedMyWalletTopupBalanceRoute
  consumerAuthenticatedMyWalletWithdrawRoute: typeof consumerAuthenticatedMyWalletWithdrawRouteWithChildren
  consumerAuthenticatedBookingsIndexRoute: typeof consumerAuthenticatedBookingsIndexRoute
  consumerAuthenticatedMyWalletIndexRoute: typeof consumerAuthenticatedMyWalletIndexRoute
}

const consumerAuthenticatedRouteChildren: consumerAuthenticatedRouteChildren = {
  consumerAuthenticatedDashboardRoute: consumerAuthenticatedDashboardRoute,
  consumerAuthenticatedEditProfileRoute: consumerAuthenticatedEditProfileRoute,
  consumerAuthenticatedFavoritesRoute: consumerAuthenticatedFavoritesRoute,
  consumerAuthenticatedNotificationsRoute:
    consumerAuthenticatedNotificationsRoute,
  consumerAuthenticatedRequestDeleteAccountRoute:
    consumerAuthenticatedRequestDeleteAccountRoute,
  consumerAuthenticatedViewProfileRoute: consumerAuthenticatedViewProfileRoute,
  consumerAuthenticatedBookingsIdRoute:
    consumerAuthenticatedBookingsIdRouteWithChildren,
  consumerAuthenticatedBookingsHistoryRoute:
    consumerAuthenticatedBookingsHistoryRoute,
  consumerAuthenticatedChatsIdRoute: consumerAuthenticatedChatsIdRoute,
  consumerAuthenticatedMyWalletAddPaymentCardRoute:
    consumerAuthenticatedMyWalletAddPaymentCardRoute,
  consumerAuthenticatedMyWalletTopupBalanceRoute:
    consumerAuthenticatedMyWalletTopupBalanceRoute,
  consumerAuthenticatedMyWalletWithdrawRoute:
    consumerAuthenticatedMyWalletWithdrawRouteWithChildren,
  consumerAuthenticatedBookingsIndexRoute:
    consumerAuthenticatedBookingsIndexRoute,
  consumerAuthenticatedMyWalletIndexRoute:
    consumerAuthenticatedMyWalletIndexRoute,
}

const consumerAuthenticatedRouteWithChildren =
  consumerAuthenticatedRoute._addFileChildren(
    consumerAuthenticatedRouteChildren,
  )

interface consumerPublicRouteChildren {
  consumerPublicAboutUsRoute: typeof consumerPublicAboutUsRoute
  consumerPublicContactUsRoute: typeof consumerPublicContactUsRoute
  consumerPublicCookiePolicyRoute: typeof consumerPublicCookiePolicyRoute
  consumerPublicFaqRoute: typeof consumerPublicFaqRoute
  consumerPublicHomeRoute: typeof consumerPublicHomeRoute
  consumerPublicOurServiceRoute: typeof consumerPublicOurServiceRoute
  consumerPublicPrivacyHealthDataRoute: typeof consumerPublicPrivacyHealthDataRoute
  consumerPublicPrivacyPolicyRoute: typeof consumerPublicPrivacyPolicyRoute
  consumerPublicTermsOfServiceRoute: typeof consumerPublicTermsOfServiceRoute
}

const consumerPublicRouteChildren: consumerPublicRouteChildren = {
  consumerPublicAboutUsRoute: consumerPublicAboutUsRoute,
  consumerPublicContactUsRoute: consumerPublicContactUsRoute,
  consumerPublicCookiePolicyRoute: consumerPublicCookiePolicyRoute,
  consumerPublicFaqRoute: consumerPublicFaqRoute,
  consumerPublicHomeRoute: consumerPublicHomeRoute,
  consumerPublicOurServiceRoute: consumerPublicOurServiceRoute,
  consumerPublicPrivacyHealthDataRoute: consumerPublicPrivacyHealthDataRoute,
  consumerPublicPrivacyPolicyRoute: consumerPublicPrivacyPolicyRoute,
  consumerPublicTermsOfServiceRoute: consumerPublicTermsOfServiceRoute,
}

const consumerPublicRouteWithChildren = consumerPublicRoute._addFileChildren(
  consumerPublicRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LandingPageV1Route: LandingPageV1Route,
  LandingPageV2Route: LandingPageV2Route,
  OnboardingRoute: OnboardingRoute,
  OnboardingSuccessRoute: OnboardingSuccessRoute,
  VideoRoute: VideoRoute,
  cleanerAuthLayoutRoute: cleanerAuthLayoutRouteWithChildren,
  cleanerAuthenticatedRoute: cleanerAuthenticatedRouteWithChildren,
  cleanerRegistrationRoute: cleanerRegistrationRouteWithChildren,
  cleanerApplicationSubmittedRoute: cleanerApplicationSubmittedRoute,
  cleanerStatusVerificationRoute: cleanerStatusVerificationRoute,
  consumerAuthLayoutRoute: consumerAuthLayoutRouteWithChildren,
  consumerAuthenticatedRoute: consumerAuthenticatedRouteWithChildren,
  consumerPublicRoute: consumerPublicRouteWithChildren,
  CheckrDisclosureConsentEmbedRoute: CheckrDisclosureConsentEmbedRoute,
  EmbedSignupRoute: EmbedSignupRoute,
  cleanerApplyCleanerBackgroundCheckRoute:
    cleanerApplyCleanerBackgroundCheckRoute,
  cleanerApplyCleanerCompletedRoute: cleanerApplyCleanerCompletedRoute,
  cleanerApplyCleanerPersonalInfoRoute: cleanerApplyCleanerPersonalInfoRoute,
  cleanerApplyCleanerSignupRoute: cleanerApplyCleanerSignupRoute,
  cleanerCleanerContactUsRoute: cleanerCleanerContactUsRoute,
  cleanerCleanerFaqRoute: cleanerCleanerFaqRoute,
  consumerbookingsBookingRoute: consumerbookingsBookingRoute,
  cleanerApplyCleanerIndexRoute: cleanerApplyCleanerIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
